export default (count: number) => ({
  dataSetName: 'Preisübersicht',
  dataName: 'Artikel',
  head: [
    {
      label: `Artikel (${count})`,
      key: 'articleName',
      col: 2,
      leftAlign: true,
    },
    {
      label: 'Lieferant',
      key: 'supplier',
      col: 2,
    },
    {
      label: 'Artikelnummer',
      key: 'articleNumber',
      col: 2,
    },
    {
      label: 'Einheit',
      key: 'unit',
      col: 2,
    },
    {
      label: 'LISTENPREIS\nBRUTTO/EINHEIT',
      key: 'listPrice',
      unit: 'EUR',
      hideUnit: true,
      col: 2,
    },
    {
      label: 'Preis',
      key: 'customPrice',
      col: 2,
      placeholder: '0,00',
      unit: 'EUR',
    },
  ],
})
